export default {
  loadFailed: 'DPI 读取失败',
  gear: {
    title: 'DPI 档位',
    cancelSelection: '取消选择',
    deleteDialog: {
      title: '删除DPI档位',
      content: '确认删除此DPI档位，删除后需重新添加不可恢复',
    },
    cancel: '取消',
    delete: '删除',
  },
  slider: {
    title: 'DPI 设置',
    independentXY: '横向X轴与纵向Y轴独立设置',
  },
}
